<div class="languages-dropdown">
  <button
    type="button"
    class="languages-toggle default-transparent-btn"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen$ | async"
  >
    <svg
      class="arrow"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z"
        fill="#none"
      />
    </svg>

    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4092 6.63988C19.4092 6.63988 19.4092 6.63988 19.4092 6.58988C18.7046 4.6661 17.4261 3.00516 15.7467 1.83174C14.0673 0.658325 12.068 0.0290527 10.0192 0.0290527C7.97047 0.0290527 5.97115 0.658325 4.29173 1.83174C2.6123 3.00516 1.33382 4.6661 0.629219 6.58988C0.629219 6.58988 0.629219 6.58988 0.629219 6.63988C-0.157656 8.81078 -0.157656 11.189 0.629219 13.3599C0.629219 13.3599 0.629219 13.3599 0.629219 13.4099C1.33382 15.3337 2.6123 16.9946 4.29173 18.168C5.97115 19.3414 7.97047 19.9707 10.0192 19.9707C12.068 19.9707 14.0673 19.3414 15.7467 18.168C17.4261 16.9946 18.7046 15.3337 19.4092 13.4099C19.4092 13.4099 19.4092 13.4099 19.4092 13.3599C20.1961 11.189 20.1961 8.81078 19.4092 6.63988ZM2.25922 11.9999C1.91245 10.6891 1.91245 9.31067 2.25922 7.99988H4.11922C3.95925 9.32842 3.95925 10.6713 4.11922 11.9999H2.25922ZM3.07922 13.9999H4.47922C4.71394 14.8917 5.04943 15.7539 5.47922 16.5699C4.49852 15.9018 3.67872 15.0239 3.07922 13.9999ZM4.47922 5.99988H3.07922C3.67009 4.97897 4.47941 4.10135 5.44922 3.42988C5.02977 4.24713 4.70436 5.1093 4.47922 5.99988ZM8.99922 17.6999C7.77098 16.7986 6.90837 15.4851 6.56922 13.9999H8.99922V17.6999ZM8.99922 11.9999H6.13922C5.95261 10.6731 5.95261 9.32668 6.13922 7.99988H8.99922V11.9999ZM8.99922 5.99988H6.56922C6.90837 4.51465 7.77098 3.2012 8.99922 2.29988V5.99988ZM16.9192 5.99988H15.5192C15.2845 5.10804 14.949 4.24582 14.5192 3.42988C15.4999 4.09795 16.3197 4.97582 16.9192 5.99988ZM10.9992 2.29988C12.2275 3.2012 13.0901 4.51465 13.4292 5.99988H10.9992V2.29988ZM10.9992 17.6999V13.9999H13.4292C13.0901 15.4851 12.2275 16.7986 10.9992 17.6999ZM13.8592 11.9999H10.9992V7.99988H13.8592C14.0458 9.32668 14.0458 10.6731 13.8592 11.9999ZM14.5492 16.5699C14.979 15.7539 15.3145 14.8917 15.5492 13.9999H16.9492C16.3497 15.0239 15.5299 15.9018 14.5492 16.5699ZM17.7392 11.9999H15.8792C15.9605 11.3363 16.0006 10.6684 15.9992 9.99988C16.0003 9.33138 15.9602 8.66345 15.8792 7.99988H17.7392C18.086 9.31067 18.086 10.6891 17.7392 11.9999Z"
        fill="#none"
      />
    </svg>

    {{ selectedLanguage$ | async | enumKey: languages | uppercase }}
  </button>

  @if (isOpen$ | async) {
    <div id="languages">
      <ul>
        @for (lang of supportedLanguages; track lang.value) {
          <li
            class="language-item"
            (click)="selectLanguage(lang.value)"
            (keydown.enter)="selectLanguage(lang.value)"
            tabindex="0"
          >
            <div>{{ lang.value | enumKey: languages | uppercase }}</div>
            <img
              [src]="
                'assets/img/lang/' + (lang.value | enumKey: languages) + '.svg'
              "
              alt="{{ lang.value | enumKey: languages | uppercase }}"
            />
          </li>
        }
      </ul>
    </div>
  }
</div>
